import React from "react";
import DatePicker from "react-multi-date-picker";
import "./CustomDateInput.css";

const CustomDateInput = ({ value, onChange, placeholder, className, style, ...props }) => {
  const selectedDate = value ? new Date(value) : null;

  const handleDateChange = (date) => {
    if (date) {
      // Convert DateObject to ISO string (YYYY-MM-DD)
      const jsDate = date.toDate();
      const year = jsDate.getFullYear();
      const month = String(jsDate.getMonth() + 1).padStart(2, '0');
      const day = String(jsDate.getDate()).padStart(2, '0');
      const isoString = `${year}-${month}-${day}`;
      onChange(isoString);
    } else {
      onChange("");
    }
  };

  return (
    <DatePicker
      {...props}
      value={selectedDate}
      onChange={handleDateChange}
      format="DD/MM/YYYY"
      placeholder={placeholder || "dd/mm/yyyy"}
      className={`custom-date-picker ${className || ''}`}
      style={{
        width: '100%',
        ...style
      }}
      inputClass={className}
      containerStyle={{
        width: '100%'
      }}
      calendarPosition="bottom-start"
      portalTarget={document.body}
      weekDays={["CN", "T2", "T3", "T4", "T5", "T6", "T7"]}
      months={[
        "Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", 
        "Tháng 5", "Tháng 6", "Tháng 7", "Tháng 8",
        "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12"
      ]}
    />
  );
};

export default CustomDateInput;
